var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-guarantee-list',{attrs:{"breakpoints":_vm.breakpoints,"text-for-brand":"Nanoleaf","text-for-year":"1 год"}})}
var staticRenderFns = []

export { render, staticRenderFns }